import { selectAlphabeticalIndexSearchQuery, useProductSelectionStore } from '../../product-selection.store';

export const useAlphabeticalIndexSearchQuery = () => {
  const alphabeticalIndexSearchQuery = useProductSelectionStore(selectAlphabeticalIndexSearchQuery);
  const isNumericSearchQuery = alphabeticalIndexSearchQuery === '0-9';

  return { alphabeticalIndexSearchQuery, isNumericSearchQuery };
};
